export const IDS_NAMES = 'IDS_NAMES';
export const CPITPCT = 'CPITPCT';
export const PY_CHART_DATA = 'PY_CHART_DATA';
export const PY_PORTFOLIO_RETURNS = 'PY_PORTFOLIO_RETURNS';
export const PY_LONG_BETA_T = 'PY_LONG_BETA_T';
export const BETA_PT = 'BETA_PT';
